import { render } from "./HomePage.vue?vue&type=template&id=29efd9b4&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=29efd9b4&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29efd9b4"]])

export default __exports__